<mat-card class="quote-card mat-elevation-z2">
  <div class="quote-card-logo">
    <img src="{{ quote.serviceLogo }}">
  </div>
  <div class="quote-card-service">
    {{ quote.serviceName }}
  </div>
  <div class="quote-card-body">
    <div class="prices">
      <div class="net">
        <div class="prefix">{{ customerCurrencyPrefix() }}</div>
        <div class="amount">{{ quote.customer.net | money:quote.customer.currency:false }}</div>
        <div class="suffix">{{ customerCurrencySuffix() }}</div>
      </div>
      @if (quote.customer.gross > quote.customer.net) {
        <div class="gross">
          <div class="prefix">{{ customerCurrencyPrefix() }}</div>
          <div class="amount">{{ quote.customer.gross | money:quote.customer.currency:false }}</div>
          <div class="suffix">{{ customerCurrencySuffix() }} <span>incl tax</span></div>
        </div>
      }
    </div>
    <div class="service-icon">
      <fa-icon [icon]="serviceIcon()" size="2x"></fa-icon>
    </div>
    @if (showEstimatedDate()) {
        <div class="estimated-delivery">
            <div class="estimated-delivery-date">
                {{ quote.estimatedDeliveryDate | decodeDate | date:'E, LLL d' }}
            </div>
            @if (showEstimatedTime()) {
                <div class="estimated-delivery-time">
                    <span i18n>by</span> {{ estimatedTime() | date:'h:mma' }}
                </div>
            }
            @if (!showEstimatedTime()) {
                <div class="estimated-delivery-time-missing">
                    <span i18n>by end of day</span>
                </div>
            }
        </div>
    }
    @if (showDiscount()) {
      <div class="discount">
        <div class="discount-percent">
          <span>{{ discountPercentage() }}</span> <span i18n>% off</span>
        </div>
      </div>
    }
  </div>
</mat-card>
